import React, { useState } from 'react';

// Se asume que Tailwind CSS está disponible para el estilizado.

const App = () => {
  const [message, setMessage] = useState('Haz clic para iniciar la captura de huella.');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleCaptureFingerprint = async () => {
    setMessage('Esperando huella...');
    setError('');
    setIsLoading(true);

    try {
      // Realizar la petición POST al servidor local
      // Asegúrate de que tu servidor local esté corriendo en http://localhost:5000
      const response = await fetch('http://localhost:5000/capturar-huella', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ action: 'capture' }), // Enviar una carga útil al servidor
      });

      // Verificar si la respuesta es exitosa
      if (!response.ok) {
        throw new Error(`Error en la petición: ${response.statusText}`);
      }

      const data = await response.json();

      // Manejar la respuesta del servidor local
      if (data.status === 'success') {
        setMessage('¡Huella capturada con éxito!');
        console.log('Datos de la huella recibidos:', data.huella);
        // Aquí podrías enviar los datos de la huella a tu backend PHP
        // usando otra petición fetch.
      } else {
        setMessage(`Error del servidor: ${data.message}`);
        console.error('Error al capturar huella:', data.message);
      }

    } catch (err) {
      // Manejar errores de red o del servidor
      setError(`Error de red o conexión: ${err.message}. Asegúrate de que el servidor local está funcionando.`);
      setMessage('');
      console.error('Error en la conexión con el servidor local:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="bg-white p-8 rounded-xl shadow-2xl w-full max-w-sm text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">Lector Biométrico Local</h1>
        
        <p className="text-gray-600 mb-6">
          Este es el cliente React que se comunica con tu servidor local.
        </p>

        <button
          onClick={handleCaptureFingerprint}
          className={`w-full text-white font-semibold py-3 px-4 rounded-xl transition-colors duration-300 ${
            isLoading ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'
          }`}
          disabled={isLoading}
        >
          {isLoading ? 'Capturando...' : 'Capturar Huella Dactilar'}
        </button>

        <div className="mt-6 p-4 rounded-lg border">
          <p className={`font-medium ${error ? 'text-red-600' : 'text-gray-800'}`}>
            {error || message}
          </p>
        </div>
      </div>
    </div>
  );
};

export default App;
